var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(" Sales ")]),_c('v-divider'),_c('v-card-text',[_c('GChart',{staticClass:"google-chart",attrs:{"data":_vm.chartData,"options":_vm.chartOptions,"type":"LineChart"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }